// Türkçe UI metinleri.
//
// Özel isimler çevrilmez: Steam, steamplayti.me, oyun adları, ağ adları
// (X, Facebook, Reddit), "Steam ID", Steam Replay. SEO yüzeyleri (sayfa
// başlıkları, meta, blog sayfaları) bilerek İngilizce kalır.
export default {
  common: {
    loading: 'Yükleniyor...',
    updating: 'Güncelleniyor...',
    never: 'Hiç',
    hoursMinutes: '{h} sa {m} dk',
    hoursOnly: '{h} sa',
    minutesOnly: '{m} dk',
    zeroMinutes: '0 dk',
    zeroHours: '0 sa'
  },
  nav: {
    blog: 'Blog',
    brandTitle: 'steamplayti.me — Steam oyun süresi takibi',
    blogTitle: 'steamplayti.me blog — Steam haberleri, ipuçları ve rehberler',
    signIn: 'Giriş yap',
    signInTitle: 'Steam ile giriş yap',
    settings: 'Ayarlar'
  },
  settings: {
    signInPerkEmail: 'Oyun süresi özet e-postasının ne sıklıkla geleceğini seç.',
    signInPerkDashboard: 'Kendi paneline tek tıkla dön.',
    signInNote: 'Girişi Steam yapar ve seni doğrudan buraya geri getirir. Şifreni asla görmeyiz.',
    lead: 'steamplayti.me hesabın ve sana gönderdiğimiz e-postalar.',
    signInTitle: 'Ayarlarını görmek için giriş yap',
    steamIdLabel: 'Steam ID',
    summaryBody: 'Steam oyun sürenin kısa bir özeti, gelen kutuna.',
    emailDesc: 'Profilini sahiplenirken onayladığın adres.',
    frequencyDesc: 'Bir seçenek seçtiğin anda kaydedilir.',
    saving: 'Kaydediliyor…',
    unclaimedTitle: 'Özeti almak için profilini sahiplen',
    metaTitle: 'Ayarlar — steamplayti.me',
    heading: 'Ayarlar',
    signInBody: 'E-posta özetini yönetmek için Steam ile giriş yap.',
    steamSignInAlt: 'Steam ile giriş yap',
    loading: 'Yükleniyor…',
    unclaimedBody: 'Paneline git ve “Bu profili sahiplen” düğmesini kullan. E-postan onaylanınca özetin ne sıklıkla geleceğini buradan seçebilirsin.',
    emailLabel: 'E-posta',
    recurrenceLabel: 'Özet e-postası',
    frequencyLabel: 'Sıklık',
    weeklyHint: 'Oyun sürenin özeti, haftada bir.',
    disabledHint: 'Özet e-postası gönderilmez.',
    signedInWithSteam: 'Steam ile giriş yapıldı',
    weekly: 'Haftalık',
    disabled: 'Kapalı',
    saved: 'Kaydedildi',
    saveFailed: 'Kaydedilemedi. Tekrar dene.',
    loadFailed: 'Ayarların şu an yüklenemedi.',
    visitDashboard: 'Paneline git'
  },
  footer: {
    toolsLabel: 'Steam Araçları',
    builtBy: 'Geliştiren:',
    gift: 'Hediye 🎁',
    donate: 'Destek ol',
    help: 'Yardım ve İletişim',
    about: 'Hakkında',
    privacy: 'Gizlilik'
  },
  landing: {
    heroTagline: 'Steam oyun süresi grafikleri, günlük saatler ve tüm oyun geçmişin.',
    subtitle: 'Steam Replay\'ini görmek için yıl sonunu beklemene gerek yok!',
    feature1: 'Günlük oyun süresi trendlerini ve oyun bazında dağılımı gör.',
    feature2: 'En çok oynanan oyunları ve günlük toplam saatleri yakala.',
    feature3: 'Steam Replay\'ini istediğin an gör -- yıl sonunu beklemeden.',
    feature5: 'Oyun süreni sen istediğin sürece takip etmeye devam ederiz.',
    featureFamily: 'Profilini sahiplen, Steam Aile Paylaşımı ile oynadığın oyunlar da sayılsın.',
    inputPlaceholder: 'Steam kullanıcı adı veya SteamID',
    showMyStats: 'İstatistiklerimi Göster',
    privacyNote: 'Kütüphaneni çekebilmemiz için Steam\'de "Oyun ayrıntıları" gizlilik ayarını Herkese Açık yap.',
    stayPublicNote: 'Oyun süreni takip edebilmemiz için profilin herkese açık kalmalı.',
    expiryNote: '60 gün açılmayan profiller otomatik olarak silinir. Profilini sahiplen, kalıcı olarak saklansın — panelindeki butona bak.',
    topGamesTitle: 'Dünün En Çok Oynananları',
    topPlayersTitle: 'Dünün En Çok Oynayanları',
    topAchieversTitle: 'Dünün Başarım Liderleri',
    uniqueGamesPlayed: 'farklı oyun oynandı',
    trackedAcrossPlayers: 'tüm oyuncularda kaydedildi',
    achievementsUnlocked: 'başarım açıldı',
    exampleProfile: 'Örnek Profil',
    exampleSince: '17 Eylül 2025\'ten beri takipte',
    exampleText: 'Grafikleri, en çok oynanan oyunları ve haftalık trendleri hazır, senkronize bir hesabı keşfet.',
    viewProfile: 'Profili görüntüle'
  },
  overlay: {
    resolvingTitle: 'Steam Profili Bulunuyor',
    syncingTitle: 'Kütüphanen Eşitleniyor',
    loadingTitle: 'Oyun Süresi Verisi Yükleniyor',
    resolvingMessage: 'Steam ID\'n bulunuyor...',
    syncingMessage: 'Oyunların ve oyun süren Steam\'den alınıyor. ',
    loadingMessage: 'Grafikler ve istatistikler hazırlanıyor...',
    syncTip: 'Bu uzun sürmemeli. Sayfayı açık bırakabilirsin; hazır olunca kendiliğinden güncellenir.',
    steamIdLabel: 'Steam ID: {id}'
  },
  status: {
    loadingPlaytime: 'Oyun süresi verisi yükleniyor...',
    profileReady: 'Profil hazır.',
    stillSyncing: 'Arka planda eşitleme sürüyor. Birazdan tekrar deneyebilirsin.',
    preparingProfile: 'Profil hazırlanıyor (çok oyunun varsa zaman alabilir)...',
    profileFound: 'Profil bulundu. Yükleniyor...'
  },
  errors: {
    statsNotPublic: 'Profilin herkese açık ama oyun istatistiklerin değil. Lütfen onları da herkese açık yapıp tekrar dene.',
    couldNotResolve: 'Steam ID çözülemedi. Kullanıcı adını veya 17 haneli ID\'yi kontrol et.',
    failedToLoadProfile: 'Bu profil yüklenemedi.',
    invalidSelection: 'Geçersiz profil seçimi.',
    failedToLoadPlaytime: 'Bu profilin oyun süresi verisi yüklenemedi.',
    previewUnavailable: 'Kütüphane önizlemen şu anda yüklenemedi.'
  },
  summary: {
    profile: 'Profil',
    exitProfile: 'Profilden çık',
    steamUser: 'Steam kullanıcısı',
    dateRange: 'Tarih Aralığı',
    selectRange: 'Aralık seç',
    selectDateRange: 'Tarih aralığı seç',
    playtime: 'Oyun Süresi',
    avgPerDay: 'Ort: {avg} / gün',
    mostPlayed: 'En Çok Oynanan',
    allTime: 'Tüm Zamanlar',
    acrossGames: '{count} oyunda | {count} oyunda',
    ranges: {
      lastWeek: 'Son Hafta',
      lastTwoWeeks: 'Son İki Hafta',
      last30: 'Son 30 Gün',
      last90: 'Son 90 Gün',
      last365: 'Son 365 Gün',
      thisWeek: 'Bu Hafta',
      thisMonth: 'Bu Ay'
    }
  },
  replay: {
    lastUnlocked: 'Son Başarımlar',
    unlocked: 'açıldı',
    longestStreak: 'En Uzun Seri',
    day: 'gün',
    inThisStreak: 'bu seride {playtime}',
    playtimeByMonth: 'Aylık Oyun Süresi',
    mostPlayedTypes: 'En Çok Oynanan Türler',
    pieCenterTop: 'En çok',
    pieCenterTypes: 'oynanan',
    playCalendar: 'Oyun Takvimi',
    less: 'Az',
    more: 'Çok'
  },
  charts: {
    updatingCharts: 'Grafikler güncelleniyor...',
    noDataYet: 'Henüz veri yok',
    alreadyCollected: 'Şimdiden {games} oyunda toplam {hours} saat kaydettik.',
    playAndComeBack: 'Biraz oyun oyna, grafiklerini görmek için yarın tekrar gel.',
    loadingPreview: 'Kütüphane önizlemen yükleniyor...',
    mostPlayedOnSteam: 'Steam\'de en çok oynadığın oyunlar',
    showingOf: '({total} oyundan {shown} tanesi gösteriliyor)',
    achievementsUnlockedCount: '{count} başarım açıldı',
    librarySnapshot: 'Bugünkü kütüphane görüntüsü.',
    couldntLoadGames: 'Oyunlarını henüz yükleyemedik. Az sonra tekrar dene.',
    noDataPeriod: 'Bu zaman aralığı için verimiz yok.',
    noPlaytimeInRange: 'Bu aralıkta oyun süresi yok',
    tryBroaderFilter: 'Son etkinliğini görmek için daha geniş bir tarih filtresi dene.',
    includeShortPlaytimes: 'Kısa süre oynanan oyunları da göster',
    totalPlaytimeTrend: 'Toplam Oyun Süresi Trendi',
    showTrend: 'Trendi göster',
    showBars: 'Çubukları göster',
    playtimeAxis: 'Oyun süresi',
    dateAxis: 'Tarih'
  },
  games: {
    yourGames: 'Oyunların',
    showingRange: '{total} oyundan {start}-{end} arası gösteriliyor',
    sortBy: 'Sırala:',
    playtime: 'Oyun Süresi',
    gameName: 'Oyun Adı',
    lastPlayed: 'Son Oynanan',
    daysPlayed: 'Oynanan Gün',
    lastActivity: 'Son Etkinlik',
    show: 'Göster:',
    unlockedCount: '{count} başarım',
    firstPage: 'İlk sayfa',
    prevPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    lastPage: 'Son sayfa',
    pageOf: 'Sayfa {page} / {total}'
  },
  achievementHistory: {
    title: 'Başarım Geçmişi',
    rangeCount: 'Bu dönemde açılan başarım yok | Bu dönemde {count} başarım açıldı | Bu dönemde {count} başarım açıldı',
    empty: 'Bu dönemde açılan başarım yok.',
    loading: 'Başarımlar yükleniyor…',
    error: 'Başarımlar yüklenemedi. Daha sonra tekrar dene.',
    newest: 'En yeni',
    oldest: 'En eski',
    lockedTitle: 'Tüm başarımların, gün gün',
    lockedBody: 'Başarım geçmişinin tamamı sahiplenilmiş profillerde gösterilir. Görmek için bu profili sahiplen.'
  },
  share: {
    cardLabel: 'Paylaş',
    onX: 'X\'te paylaş',
    onFacebook: 'Facebook\'ta paylaş',
    onReddit: 'Reddit\'te paylaş',
    native: 'Paylaş…',
    copyLink: 'Bağlantıyı kopyala',
    linkCopied: 'Bağlantı kopyalandı'
  },
  claim: {
    button: 'Bu profili sahiplen',
    close: 'Kapat',
    forcedIntro: 'Bu yeni bir profil — verilerin hazır olduğunda haber verebilmemiz için önce e-postanı doğrulaman gerekiyor.',
    step1: 'Adım 1 / 2',
    step2: 'Adım 2 / 2',
    heading: 'Profilini sahiplen',
    intro: 'Sahiplenilmemiş profiller 60 gün ziyaret edilmezse silinir. Sahiplenilmiş profil hiç silinmez — ne kadar uzak kalırsan kal, oyun süresi geçmişin kalıcı olarak saklanır.',
    stepSignIn: 'Steam ile giriş yap — bu, profilin senin olduğunu kanıtlar.',
    stepConfirm: 'E-postanı doğrula. Sahiplenme ancak ondan sonra tamamlanır.',
    steamSignInAlt: 'Steam ile giriş yap',
    signInNote: 'Girişi Steam yürütür ve seni doğrudan buraya geri getirir. Şifreni asla görmeyiz ve yalnızca kendi hesabına ait profili sahiplenebilirsin.',
    notPublic: 'Profilini sahiplenebilmemiz için Steam profilinin ve "Oyun ayrıntıları" ayarının Herkese Açık olması gerekiyor — kütüphaneni ancak öyle okuyabiliyoruz. Steam gizlilik ayarlarından ikisini de aç, sonra bu sayfayı yenile.',
    privateHeading: 'Kütüphaneni herkese açık yap',
    playtimeHeading: 'Oynama süreni görünür yap',
    playtimePrivate: 'Oyunlarını görebiliyoruz ama Steam hepsinde 0 saat gösteriyor — yani takip edecek bir şey olmaz. Steam\'de Profili Düzenle → Gizlilik Ayarları\'na git, Oyun ayrıntıları altında toplam oynama süresini gizli tutan kutunun işaretini kaldır, sonra bu sayfayı yenile.',
    confirmHeading: 'E-postanı doğrula',
    signedInAs: '{id} olarak giriş yaptın. Bir e-posta ekle ve göndereceğimiz bağlantıya tıkla. Bunu yapana kadar hiçbir şey kaydedilmez — bu pencereyi kapatırsan baştan başlarsın.',
    // Escaped `@` — see the note on this key in en.js. A bare @ makes the
    // production message compiler throw and the modal step renders nothing.
    emailPlaceholder: "sen{'@'}ornek.com",
    emailAria: 'E-posta adresi',
    sending: 'Gönderiliyor...',
    sendLink: 'Doğrulama bağlantısı gönder',
    providersNote: 'Gmail, Outlook, Hotmail, Yahoo, iCloud, Yandex ve Proton adresleri.',
    wrongProfile: 'Yanlış profil',
    mismatchHeading: 'Bu, o profil değil',
    mismatchBody: 'Steam seni {signedId} olarak giriş yaptırdı ama bu sayfa {pageId} profiline ait. Yalnızca kendi Steam hesabının profilini sahiplenebilirsin.',
    goToMyProfile: 'Profilime git',
    almostThere: 'Az kaldı',
    checkInbox: 'Gelen kutunu kontrol et',
    sentBody: '{email} adresine bir bağlantı gönderdik. Tıkladığında profilin sahiplenilmiş olur. Bağlantı 48 saat içinde geçersizleşir ve kullanana kadar hiçbir şey kaydedilmez.',
    sendAgain: 'Tekrar gönder',
    useDifferent: 'Başka bir adres kullan',
    mailError: 'E-posta gönderilemedi. Tekrar dene.'
  },
  // Maildeki onay bağlantısından dönüşte bir kez gösterilir. Mesajlarda çıplak
  // `@` kullanma — claim.emailPlaceholder'daki nota bak.
  claimConfirmed: {
    dismiss: 'Anladım',
    successHeading: 'Profilin sahiplenildi',
    successBody: 'Hepsi bu — bu profil artık kalıcı olarak senin. Oyun süresi geçmişin ne kadar uzak kalırsan kal saklanır, hareketsizlik yüzünden asla silinmez.',
    alreadyHeading: 'Zaten sahiplenilmiş',
    alreadyBody: 'Bu profil daha önce sahiplenilmiş, yapılacak bir şey kalmamış. Her şey hazır.',
    expiredHeading: 'Bu bağlantı artık geçerli değil',
    expiredBody: 'Onay bağlantıları 48 saat sonra geçersiz olur ve yalnızca bir kez kullanılabilir. Profilini aç ve yeni bir bağlantı için sahiplenmeyi baştan başlat.',
    serverHeading: 'Bir şeyler ters gitti',
    serverBody: 'Sahiplenmeyi şu anda tamamlayamadık. Bağlantın hâlâ geçerli olabilir — az sonra tekrar dene ya da profilinden sahiplenmeyi yeniden başlat.'
  },
  notFound: {
    title: 'Sayfa Bulunamadı',
    text: 'Bu sayfayı bulamadık. Oyun sürelerini takip etmeye devam etmek için panele dön.',
    goHome: 'Ana Sayfaya Git'
  }
}
